import { MultiPlayerInfo, UserDetails } from "../../consts/types";

export enum GameStatus {
  PLAY = "play",
  GAME_OVER = "game_over"
}
export type MatchState = {
  status: GameStatus;
  timer: number;
  timerDuration: number;
  level: number;
  dictionary: Record<string, string>;
  totalPoints: number;
  placeHodler: string;
  currentSelection: string;
  lotteryWords: string[];
  originalLotteryWords: string[];
  wordIndexSelection: number[];
  wordInput: string;
  wordCurrent: string;
  wordsGroupedByLength: Record<string, string[]> | null;
  wordsFound: Record<string, string[]>;
  wordHistory: Record<string, Record<string, string[]>>;
  mapCombinationsCount: Record<string, number> | null;
  bonusSeconds: Array<{ seconds: number; id: number }>;
};

export type MatchActions = {
  configMatch: (lotteryWords: string[], dictionary: Record<string, string>) => void;
  bonusSecondTransitionEnd: (id: number) => void;

  setGameStatus: (status: GameStatus) => void;

  updateTimer: (delta: number) => void;
  getTimerDuration: () => number;
  getTimerAndPoints: () => { timer: number; points: number };

  updateWordIndexSelection: (indexes: number[]) => void;

  updateWordsGroupedByLength: (w: string) => void;
  updateWordsFoundTimerAndPoint: (w: string) => void;

  setMapCombinationsCount: (w: string) => void;
  getMapCombinationsCount: () => Record<string, number> | null;

  startRound: (index?: number) => void;

  setWordInput: (w: string) => void;

  setWordCurrent: (w: string) => void;

  resetMatchState: () => void;
  resetTimeDuration: () => void;
  resetCurrentSelection: () => void;
};

export enum PortalType {
  WELCOME = "WELCOME",

  PRIVACY_POLICY = "PRIVACY_POLICY",

  TERMS_CONDITION = "TERMS_CONDITION",
  PROFILE_MENU = "PROFILE_MENU",
  STATS = "STATS"
}

export enum PageType {
  LOADING = "LOADING",
  PLAY = "PLAY",
  LOGIN = "LOGIN",
  START = "START",
  MULTI_PLAYER_START = "MULTI_PLAYER_START",

  MULTI_PLAYER_START_FROM_URL = "MULTI_PLAYER_START_FROM_URL",
  COLLECT_USERDATA = "COLLECT_USERDATA"
}

export enum PageTypeStart {
  PLAY_SCREEN_SELECT = "PLAY_SCREEN_SELECT",
  MULTIPLAYER_CREATE_MATCH = "MULTIPLAYER_CREATE_MATCH",
  MULTIPLAYER_JOIN_MATCH = "MULTIPLAYER_JOIN_MATCH"
}

export type InnerPageNavigation = {
  type: PageTypeStart;
  data?: Record<string, unknown>;
};

export type InnerPortalNavigation = {
  data?: Record<string, unknown>;
};
export type NavigationState = {
  currentPage: PageType;
  innerPages: { [key in PageType]: InnerPageNavigation | null };
  portals: { [key in PortalType]: InnerPortalNavigation | null };
};

export type NavigationActions = {
  showPortal: (portal: PortalType, data: InnerPortalNavigation | null) => void;
  moveToPage: (page: PageType) => void;
  moveToInnerPage: (
    page: PageType,
    innerPage: PageTypeStart | null,
    data?: Record<string, unknown>
  ) => void;
  closeInnerPage: () => void;
};

type Assets = {
  media: Record<string, AudioBuffer>;
};

export enum PWA_STATUS {
  INSTALLABLE = "INSTALLABLE",

  INSTALLED = "INSTALLED",
  UNKNOWN = "UNKNOWN"
}

export type MultiPlayerState = {
  players: MultiPlayerInfo[];
};

export type MultiPlayerConfigActions = {
  setPlayers: (players: MultiPlayerInfo[]) => void;
};

export type GameConfigState = {
  isLoading: boolean;
  language: string;
  dict: Record<string, string> | null;
  lotteryWords: string[];
  assets: Assets;
  audioContext: AudioContext | null;
  settings: {
    audio: boolean;
    userLogged: UserDetails | null;
    welcomeShown: boolean;
  };
  pwa: { promptEvt: { prompt: () => void } | null; isInstalled: PWA_STATUS };
};

export type GameConfigActions = {
  initConfig: (config: {
    language: string;
    dict: Record<string, string> | null;
    lotteryWords: string[];
  }) => void;

  setLoading: (isLoading: boolean) => void;
  setAssets: (assets: Assets) => void;
  setAudioContext: (assets: AudioContext) => void;
  audioToggle: () => void;
  setUserLoggedFlag: (userLogged: UserDetails) => void;
  setUserWelcomeShown: (status: boolean) => void;
  setPwaPrompt: (promptEvt: { prompt: () => void }) => void;
  setPwaIsInstalled: (isInstalled: PWA_STATUS) => void;
};
